import {Component, OnInit} from '@angular/core';
import {CommonModule} from '@angular/common';
import {Router, ActivatedRoute} from '@angular/router';
import {DisinfectionprogramService} from '@services/disinfectionprogram.service';
import {ToastrService} from 'ngx-toastr';
import {LoaderService} from '@services/loader.service';

@Component({
    selector: 'app-disinfection-detail',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './disinfection-detail.component.html',
    styleUrl: './disinfection-detail.component.scss'
})
export class DisinfectionDetailComponent implements OnInit {
    public disinfectionId: number;
    public disinfectionDetail: any;
    public loading = false;
    public disinfectionlist: Array<{id: number; name: string}> = [];

    constructor(
        private router: Router,
        private route: ActivatedRoute,
        private disinfectionService: DisinfectionprogramService,
        private toastr: ToastrService,
        private loader: LoaderService
    ) {}

    ngOnInit(): void {
        this.disinfectionId = this.route.snapshot.params['id'];
        this.loadTypeListThenDetails();
    }

    private loadTypeListThenDetails(): void {
        this.loading = true;
        this.loader.showLoader();
        this.disinfectionService.getDisInfectionProgramList().subscribe({
            next: (result: any) => {
                const list = result || [];
                this.disinfectionlist = list.map((t: any) => ({
                    id: Number(t.id),
                    name: t.name || ''
                }));
                this.loadDisinfectionDetails(this.disinfectionId);
            },
            error: () => {
                this.disinfectionlist = [];
                this.loadDisinfectionDetails(this.disinfectionId);
            }
        });
    }

    private getTypeNameById(typeId?: number): string | undefined {
        if (!typeId) return undefined;
        return this.disinfectionlist.find((t) => t.id === Number(typeId))?.name;
    }

    loadDisinfectionDetails(id: number): void {
        if (!id) return;
        this.loading = true;
        this.loader.showLoader();
        this.disinfectionService.getDisInfectionById(id).subscribe({
            next: (response: any) => {
                const instructions =
                    response?.instructionsList?.map(
                        (i: any) => i.instructions
                    ) || [];

                const typeName =
                    this.getTypeNameById(response?.disinfectionTypeId) || '-';

                this.disinfectionDetail = {
                    programName: response?.disinfectionProgramName || '-',
                    disinfectionTypeName: typeName,
                    instructions
                };
                this.loading = false;
                this.loader.hideLoader();
            },
            error: (err) => {
                this.loading = false;
                this.loader.hideLoader();
                this.toastr.error('Failed to load disinfection details');
                console.error(err);
            }
        });
    }

    goBack(): void {
        this.router.navigate(['/disinfection-list']);
    }

    editDisinfection(): void {
        this.router.navigate(['/edit-disinfection', this.disinfectionId]);
    }
}
